<template>
    <div>
        <div class="content-caption dashed">
            <span>入账单信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>单据号：</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.no}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>标题：</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.title}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间：</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.createTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建人：</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.creatorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核人：</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.auditorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>说明：</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.memo || '无'}}</span>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>资产信息</span>
        </div>
        <div class="simple-row">
            <div class="right">
                <span>已选择({{(fiscalClearInfo.fiscalEnterItemList || []).length}})</span>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="fiscalClearInfo.fiscalEnterItemList" border tooltip-effect="dark" style="width: 100%">
                <el-table-column align="left" prop="devcInnerCode" min-width="160" label="资产编号" fixed show-overflow-tooltip></el-table-column>
                <!--<el-table-column align="left" prop="retailerComName" label="机构名称" width="200" fixed show-overflow-tooltip></el-table-column>-->
                <el-table-column align="left" prop="retailerComFullName" label="部门全称" width="200" fixed show-overflow-tooltip></el-table-column>
                <el-table-column prop="assetType" width="100" label="管理方式" align="center" fixed show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{assetTypeMap[rows.row.assetType]}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="title" label="资产描述全称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="name" label="名称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="model" label="型号" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="fixedSpec" label="规格" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="tmpNo" min-width="250" label="系统编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="vendorUkno" width="250" label="商品标识码" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="innerCode" min-width="120" label="资产定义编码" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="innerDevcCatFullName" min-width="200" label="资产分类全称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcGroupFullName" width="100" label="维保分组" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="innerDevcBrandCode" min-width="150" label="资产品牌编码" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="innerDevcBrandName" min-width="150" label="资产品牌" show-overflow-tooltip></el-table-column>
                <el-table-column prop="assetKindName" width="150" label="财务类别" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="assetNature" width="90" label="资产属性" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{assetNatureMap[rows.row.assetNature]}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="deprSpecCode" min-width="150" label="折旧分摊规则编码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="acctEnterWay" width="90" label="入账方式" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{acctEnterWayMap[rows.row.acctEnterWay]}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="fiscalAcctFlag" width="100" label="财务在账">
                    <template slot-scope="rows">
                        <span>{{rows.row.fiscalAcctFlag == 1 ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="batchNo" width="160" label="批次号" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column align="right" prop="orgWorth" width="80" label="原值(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.orgWorth != null">{{rows.row.orgWorth.toFixed(2)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fiscalInTime" align="center" width="120" label="入账时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="onsetDate" align="center" width="150" label="折旧起算日期"></el-table-column>
                <el-table-column align="left" min-width="100" label="折旧算法">
                    <template slot-scope="rows">
                        <span>{{deprMethodCodeMap[rows.row.deprMethodCode]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="durableLife" align="right" width="120" label="预计使用年限(月)"></el-table-column>
                <el-table-column align="right" prop="netWorth" width="80" label="净值(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.netWorth != null">{{rows.row.netWorth.toFixed(2)}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="deprMonth" width="100" label="最后折旧月份">
                    <template slot-scope="rows">
                        <span v-if="rows.row.deprMonth != null && rows.row.deprMonth > 0">{{rows.row.deprMonth}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="aggtDeprWorth" width="100" label="累计折旧值(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.aggtDeprWorth != null">{{rows.row.aggtDeprWorth.toFixed(2)}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="fiscalAbnormal" width="100" label="财务异常">
                    <template slot-scope="rows">
                        <span>{{rows.row.fiscalAbnormal ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="quantity" width="100" label="入账数量"></el-table-column>
                <el-table-column align="center" prop="theUnit" min-width="50" label="单位"></el-table-column>
                <el-table-column align="left" prop="handleDesc" min-width="100" label="处理说明" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import shopDeviceApi from '../../api/shopDevc'
    import assetFiscalApi from '../../api/assetFiscal'
    //
    export default {
        name: 'swb-asset-fiscal-enter-voucher-view',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '资产入账单详情',
        props: ['id'],
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                fiscalClearInfo: {},
                //
                acctEnterWayMap: getEnumMap('acctEnterWay', "value2text"),
                assetTypeMap: getEnumMap("assetType", "value2text"),
                assetNatureMap: getEnumMap("assetNature", "value2text"),
                deprMethodCodeMap: {}
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.deprMethodCodeMap = getEnumMap("assetDeprMethod", "name2text");
            this.getAssetFiscalEnterVoucher();
        },
        methods: {
            getAssetFiscalEnterVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                assetFiscalApi.getAssetFiscalEnterVoucherInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let fiscalClearInfo = result.data;
                        self.fiscalClearInfo = Utils.merge({}, fiscalClearInfo);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/assetFiscal/AssetFiscalEnterVoucherView.vue